<template>
    <icon-base :width="size + 'px'" :fill="color">
        <g>
            <g>
                <path class="st0" d="M174.4,53.6h46.4c1.6,0,2.4-2,1.3-3.1L175.6,4.1c-1.1-1.1-3.1-0.3-3.1,1.3v46.4    C172.5,52.8,173.4,53.6,174.4,53.6z"/>
                <path class="st1" d="M221.5,65h-52.6c-2.8,0-5.1-2.3-5.1-5.1V4.7c0-2-1.6-3.7-3.7-3.7H38.9c-7.7,0-14,6.3-14,14v221    c0,7.7,6.3,14,14,14h172.3c7.7,0,14-6.3,14-14V68.7C225.1,66.7,223.5,65,221.5,65z M132.4,143.6c1.6,0,3.3,0,4.9,0    c3.8,0,7.7,0,11.5,0c2.5,0,4.6,1.2,5.6,3.1c1,1.7,0.9,3.7-0.1,5.5c-1.5,2.6-4.1,2.9-5.9,2.9l0,0c-7.7,0-22.8,0-34,0H65    c-0.3,0-0.6,0-0.9,0c-4-0.1-6.6-2.3-6.7-5.6c0-1.5,0.5-2.9,1.5-4c1.2-1.2,3.1-1.9,5.3-1.9c14.2,0,35.9,0,53.6,0H132.4z M79.2,74.8    c-0.6-0.6-1.5-1-2.4-1.4c-1.1-0.4-2.6-0.8-4.6-1.3c-2.8-0.7-5.2-1.4-6.9-2.2c-1.9-0.8-3.6-2-4.9-3.6c-1.4-1.7-2.2-3.9-2.2-6.7    c0-3.3,1.2-6.1,3.6-8.5c2.1-2.1,4.8-3.4,8.1-4.1v-2.6c0-1.2,0.4-2.1,1.1-2.9c1.4-1.5,4.3-1.5,5.7,0c0.7,0.7,1.1,1.7,1.1,2.8v2.5    c3.5,0.6,6.7,2,9.3,4.2c1.1,0.8,1.7,2.1,1.7,3.5c0,1-0.3,2-0.9,2.7c-0.8,1.1-1.8,1.3-2.5,1.3c-0.5,0-0.9-0.1-1.4-0.2    c-0.3-0.1-0.8-0.3-1.5-0.8c-1.5-1.1-2.9-1.8-4.1-2.3s-2.7-0.7-4.4-0.7c-2.1,0-3.7,0.4-4.9,1.3c-1.1,0.8-1.6,1.9-1.6,3.3    c0,0.9,0.3,1.6,0.8,2.2c0.7,0.7,1.5,1.2,2.5,1.5c1.1,0.4,2.7,0.9,4.8,1.4c2.7,0.7,5,1.4,6.8,2.1c1.9,0.8,3.5,1.9,4.8,3.5    c1.4,1.6,2.1,3.8,2.1,6.5c0,3.2-1.2,6-3.4,8.3c-2,2-4.7,3.4-8,4v2.6c0,1.2-0.4,2.1-1.1,2.8c-0.7,0.8-1.7,1.1-2.8,1.1    c-1.1,0-2.1-0.4-2.8-1.1c-0.7-0.7-1.1-1.7-1.1-2.8v-2.4c-1.9-0.2-3.7-0.7-5.4-1.3c-2.1-0.7-4-1.7-5.5-3c-0.6-0.4-1-0.9-1.3-1.5    s-0.4-1.2-0.4-2c0-1,0.3-1.9,0.9-2.7c0.8-1.1,1.8-1.3,2.5-1.3c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.8,0.4,1.4,0.7    c1.7,1.1,3.3,1.9,4.8,2.4s3.2,0.7,4.9,0.7c2.2,0,4-0.4,5.1-1.2c1.1-0.8,1.6-1.8,1.6-3.3C79.9,75.8,79.7,75.2,79.2,74.8z     M58.9,120.3c1.2-1.2,2.9-1.8,5-1.9c15.2,0,30.3,0,45.5,0c3.9,0,6.4,2.2,6.4,5.6c0,1.6-0.5,3-1.5,4c-1.1,1.2-2.9,1.8-5,1.8    c-5.4,0-10.7,0-16.1,0h-6.8H80c-2.2,0-4.5,0-6.7,0c-3.2,0-6.4,0-9.5,0c-3.8,0-6.4-2.3-6.5-5.6C57.3,122.7,57.8,121.4,58.9,120.3z     M191.9,202.2c-1.5,2.6-4.1,2.9-6,2.9l0,0c-8.2,0-49.7,0-70.2,0H65c-0.3,0-0.6,0-0.9,0c-4-0.1-6.6-2.3-6.7-5.6    c0-1.5,0.5-2.9,1.5-4c1.2-1.2,3.1-1.9,5.3-1.9c14.9,0,62,0,89.6,0H170c1.6,0,3.3,0,4.9,0c3.8,0,7.7,0,11.5,0    c2.5,0,4.6,1.2,5.6,3.1C192.9,198.4,192.9,200.4,191.9,202.2z"/>
            </g>
        </g>
    </icon-base>
</template>
<script>

export default {
name: 'iconCash',
components: {
    iconBase: () => import('@/common/components/iconBase.vue')
},
props: {
    size: {
        type: Number,
        default: 20
    },
    color: {
        type: String,
        default: 'var(--main-navy)'
    },
    
}
}
</script>

<style scoped>
    .st0{fill:#FF8362;}
	.st1{fill:#F9947D;}
</style>
